import React, { Component } from "react";
import { connect } from "react-redux";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css";
import { Grid, Col, Row, ControlLabel, Button } from "react-bootstrap";
import Card from "../../../components/Card/Card";
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
// import { dominio } from "../../../routes_backend/routes";
import moment from "moment";
import Swal from 'sweetalert2';
import "./CSS/styles.css";
import _ from "lodash";
import Loading from "../../../views/Loading";
import { dominio } from "../../../routes_backend/routes.jsx";



const myGridModalArticulos = React.createRef();
const gridRef = React.createRef();




class Solicitud_Compras_Servicio extends Component {
  constructor(props) {
    super(props);
    const today = moment().format('YYYYMMDD');

    // Initial source setup
    const source = {
      localdata: [],
      datatype: "array",
      datafields: [
        { name: 'Codigo', type: 'string' },
        { name: 'Descripcion', type: 'string' },
      ],
      id: 'id'
    };
    this.state = {
      dataAdapter: new jqx.dataAdapter(source),
      dataComboProyectos: [],  // Aquí se guarda la fuente del dropdown

      date: today,
      fecha_contabilizacion: today,
      fecha_valido_hasta: today,
      fecha_documento: today,
      fecha_necesaria: today,
      isModalOpen: false,

      data: [],

      columnsCodigos: [
        {
          text: "",
          columntype: 'button',
          width: "5%",
          cellsrenderer: () => '+',
          buttonclick: (row) => {
            const dataRecord = myGridModalArticulos.current.getrowdata(row);
            const selectedRowIndex = gridRef.current.getselectedrowindex();

            console.log(selectedRowIndex);

            if (selectedRowIndex >= 0) {
              // Obtén los datos actuales del grid
              const currentData = gridRef.current.getrowdata(selectedRowIndex);

              // Verifica si currentData tiene todos los campos necesarios
              console.log("Current data:", currentData);

              // Actualiza la fila con los nuevos datos
              gridRef.current.updaterow(selectedRowIndex, {
                ...currentData,
                Codigo: dataRecord.ItemCode,
                Descripcion: dataRecord.ItemName,
                Stock: dataRecord.OnHand,
                Precio_Info: dataRecord.LastPurPrc,
                Comprometido: dataRecord.IsCommited
              });

              // Actualiza el estado con los datos modificados
              this.setState(prevState => {
                const updatedData = [...prevState.data];
                updatedData[selectedRowIndex] = {
                  ...updatedData[selectedRowIndex],
                  Codigo: dataRecord.ItemCode,
                  Descripcion: dataRecord.ItemName,
                  Stock: dataRecord.OnHand,
                  Precio_Info: dataRecord.LastPurPrc



                };
                return { data: updatedData };
              });
            } else {
              console.error("No row is selected or invalid row index");
            }

            // Cierra el modal
            this.closeModal();
          },
          editable: false
        }
        ,



        { text: "Codigo", datafield: "ItemCode", width: "20%" },
        { text: "Descripcion", datafield: "ItemName", width: "50%" },
        { text: "Stock", datafield: "OnHand", width: "15%" },
        { text: "Precio", datafield: "LastPurPrc", width: "10%" },
        { text: "Comprometido", datafield: "IsCommited", width: "10%" },
      ],
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeDepartamento = this.onChangeDepartamento.bind(this);
    this.onChangeCategoria = this.onChangeCategoria.bind(this);

  }

  componentDidMount() {
    this.dataDepartamento();
    this.dataCategoria();
    this.dataProyectos();
    this.dataAlmacenes();
    this.dataIndicadorImpuesto();
    this.dataLocalidadD1();
    this.dataCentroCostosD2();
    this.dataDepartamentosD3();
  }

  handleDateChangeFechaContabilizacion = (e) => {
    const fecha_contabilizacion = e.target.value;
    const date_fecha_contabilizacion = moment(fecha_contabilizacion).format('YYYYMMDD');
    this.setState({
      fecha_contabilizacion: fecha_contabilizacion,
      fechaContabilizacion: date_fecha_contabilizacion,
    });
    // console.log(date_fecha_contabilizacion);
  }

  handleDateChangeFechaValidoHasta = (e) => {
    const fecha_valido_hasta = e.target.value;
    const date_fecha_valido_hasta = moment(fecha_valido_hasta).format('YYYYMMDD');
    this.setState({
      fecha_valido_hasta: fecha_valido_hasta,
      fechaValidoHasta: date_fecha_valido_hasta,
    });
    // console.log(date_fecha_valido_hasta);
  }

  handleDateChangeFechaDocumento = (e) => {
    const fecha_documento = e.target.value;
    const date_fecha_documento = moment(fecha_documento).format('YYYYMMDD');
    this.setState({
      fecha_documento: fecha_documento,
      fechaDocumento: date_fecha_documento,
    });
    // console.log(date_fecha_documento);
  }

  handleDateChangeFechaNecesaria = (e) => {
    const fecha_necesaria = e.target.value;
    const date_fecha_necesaria = moment(fecha_necesaria).format('YYYYMMDD');
    this.setState({
      fecha_necesaria: fecha_necesaria,
      fechaNecesaria: date_fecha_necesaria,
    });
    // console.log(date_fecha_necesaria);
  }

  dataDepartamento = async () => {


    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }

    this.setState({
      message: "",
      isLoading: true,
    });

    const response = fetch(`${dominio}/get_ListaDepartamentos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
        password
      }),
    });

    response
      .then(async (res) => {
        let data = await res.json();

        if (Object.entries(data).length === 0) {
          return this.setState({
            message: "no data",
            isLoading: false,
          });
        }
        let array_source = data.map(element => [
          element.Code,
          element.Name,
        ]);

        this.setState({
          isLoading: false,
          message: "",
          dataComboDepartamento: array_source,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          message: "error in server",
        });
      });
  };

  dataCategoria = async () => {


    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }

    this.setState({
      message: "",
      isLoading: true,
    });

    const response = fetch(`${dominio}/get_ListaCategorias`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
        password
      }),
    });

    response
      .then(async (res) => {
        let data = await res.json();

        if (Object.entries(data).length === 0) {
          return this.setState({
            message: "no data",
            isLoading: false,
          });
        }
        let array_source = data.map(element => [
          // element.FldValue,
          Number(element.Series),
          element.SeriesName,
        ]);

        this.setState({
          isLoading: false,
          message: "",
          dataComboCategoria: array_source,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          message: "error in server",
        });
      });
  };

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  onChangeDepartamento = (event) => {
    this.setState({

      totalKms: '',
      is_descriptionDepartamentos: "Seleccione...",


    });
    const selectedValue = event.target.value;
    const selectedOption = this.state.dataComboDepartamento.find(res => res[1] === selectedValue);

    this.setState({
      [event.target.name]: selectedValue,
      selectedDepartamentoId: selectedOption ? selectedOption[0] : '', // Actualiza el estado con res[0]
    }, () => {
      // console.log(this.state.selectedDepartamentoId); // Imprime la nueva variable después de que el estado se actualice
    });
  };

  onChangeCategoria = (event) => {
    this.setState({

      totalKms: '',
      is_descriptionCategorias: "Seleccione...",


    });
    const selectedValue = event.target.value;
    const selectedOption = this.state.dataComboCategoria.find(res => res[1] === selectedValue);

    this.setState({
      [event.target.name]: selectedValue,
      selectedCategoriaId: selectedOption ? selectedOption[0] : '', // Actualiza el estado con res[0]
    }, () => {
      // console.log(this.state.selectedCategoriaId); // Imprime la nueva variable después de que el estado se actualice
    });
  };

  clear = () => {
    this.setState({
      cantidad: '',
      documentoWisap: '',
      documentoBase: '',
      vehiculo: '',
      origen: '',
      destino: '',
      totalKms: '',
      kmsVacios: '',
      kmsCargados: '',
      piloto: '',
      is_descriptionOrigenes: "Seleccione...",
      is_descriptionDestinos: "Seleccione...",
      is_descriptionPiloto: "Seleccione...",
      is_descriptionProductos: "Seleccione...",
      selectedOrigenId: '',
      selectedDestinoId: '',
      value_piloto: '',
      value_vehiculo: '',
      metrosCubicosPorViaje: '',
      horarioEntrega: '',

    });
  };

  onChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      if (name === 'is_descriptionPiloto') {
        this.updateVehiculo(value);
      }
    });
  }

  openModal = () => {
    this.setState({
      isModalOpen: true,
      sourceGridCodigos: null, // Inicializa con null o vacío
    });

    let username = "";
    let password = "";

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);
    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push("");
    }

    this.setState({
      message: '',
      isLoading: true,
    });

    fetch(`${dominio}/get_ListaCodigos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
        password,
      }),
    })
      .then(async (res) => {
        let dataCodigos = await res.json();
        const temp_res = Object.entries(dataCodigos).length === 0;
        if (temp_res === true) {
          return this.setState({
            isLoading: false,
            message: "No data",
            sourceGridCodigos: "",
          });
        }

        let source_Array = [];
        dataCodigos.forEach((element) => {
          let array = [
            element.ItemCode,
            element.ItemName,
            element.OnHand,
            element.LastPurPrc,
            element.IsCommited
          ];
          source_Array.push(array);
        });

        let temp_source_grid = {
          localdata: source_Array,
          datafields: [
            { name: "ItemCode", type: "string", map: "0" },
            { name: "ItemName", type: "string", map: "1" },
            { name: "OnHand", type: "string", map: "2" },
            { name: "LastPurPrc", type: "string", map: "3" },
            { name: "IsCommited", type: "string", map: "4" }
          ],
          datatype: "array",
        };

        this.setState({
          sourceGridCodigos: new jqx.dataAdapter(temp_source_grid),
          isLoading: false,
          message: "",
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          message: "error in server",
          isLoading: false,
        });
      });
  }

  closeModal = () => {
    this.setState({
      isModalOpen: false,
      sourceGridCodigos: null,  // Limpia el adaptador del grid al cerrar el modal
    });
  }

   handleFileChange = (event) => {


    const file = event.target.files[0];

    if (file) {
      if (file.size > 16 * 1024 * 1024) { // 16 MB
        alert("El archivo excede el tamaño máximo permitido (16 MB).");
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const binary = reader.result;
        const base64Data = btoa(
          new Uint8Array(binary).reduce((data, byte) => data + String.fromCharCode(byte), "")
        );
        this.setState({
          file: base64Data,
        });
      };
      reader.readAsArrayBuffer(file);
    }


  };


  handleSubmit = (event) => {
    event.preventDefault();

    // Definir la nueva fila vacía
    const newRow = {
      Codigo: "",
      Descripcion: "",
      Proyecto: "",
      U_Fase: "",
      WhsCode: "",
      OcrCodeD1: "",
      OcrCodeD2: "",
      OcrCodeD3: "",
      Stock: "",
      Precio_Info: "",
      Cantidad: "",
      Code: "",
      Total: "",
    };

    // Mantener los datos actuales en el estado y agregar la nueva fila al final
    this.setState(prevState => ({
      data: [...prevState.data, newRow]  // Mantener todas las filas anteriores y agregar una nueva
    }));
  };

  handleDelete = (rowIndex) => {
    const newData = this.state.data.filter((_, index) => index !== rowIndex);
    this.setState({ data: newData });
  };

  createListaProyectos = (row, cellvalue, editor) => {
    if (!editor) {
      console.error('Editor no está definido.');
      return;
    }

    editor.jqxDropDownList({
      source: this.state.dataComboProyectos,
      displayMember: 'label',
      valueMember: 'value',
      filterable: true,
      // autoDropDownHeight: true,
    });
    editor.on('select', (event) => {
      // console.log(event);
      // console.log(event.args.type);

      const args = event.args;
      // console.log(args.item.checked);
      let selectedProject = ""
      if (args && args.item) {
        selectedProject = args.item.value;
        // console.log(selectedProject);

        this.setState(prevState => {
          const updatedData = [...prevState.data];
          updatedData[row].Proyecto = selectedProject;
        });

        // Condición para verificar si el tipo de evento es "mouse"
        if (event.args.type === "mouse") {
          // Ejecuta la función solo si fue un evento de tipo "mouse"
          this.dataFases(selectedProject);
        }


      } else {
        console.error('No se pudo obtener el item seleccionado:', args);
      }
    });
  };

  createListaFases = (row, cellvalue, editor) => {
    if (!editor) {
      console.error('Editor no está definido.');
      return;
    }

    editor.jqxDropDownList({
      source: this.state.dataComboFases,
      displayMember: 'label',
      valueMember: 'value',
      filterable: true,
      // autoDropDownHeight: true,
    });
    editor.on('select', (event) => {


      const args = event.args;
      // console.log(args.item.checked);
      let selectedFases = ""
      if (args && args.item) {
        selectedFases = args.item.value;
        // console.log(selectedFases);

        this.setState(prevState => {
          const updatedData = [...prevState.data];
          updatedData[row].U_Fase = selectedFases;

        });




      } else {
        console.error('No se pudo obtener el item seleccionado:', args);
      }
    });
  };

  createListaAlmacenes = (row, cellvalue, editor) => {
    if (!editor) {
      console.error('Editor no está definido.');
      return;
    }

    editor.jqxDropDownList({
      source: this.state.dataComboAlmacenes,
      displayMember: 'label',
      valueMember: 'value',
      filterable: true,
      // autoDropDownHeight: true,
    });
    editor.on('select', (event) => {


      const args = event.args;
      // console.log(args.item.checked);
      let selectedAlmacen = ""
      if (args && args.item) {
        selectedAlmacen = args.item.value;
        // console.log(selectedAlmacen);

        this.setState(prevState => {
          const updatedData = [...prevState.data];
          updatedData[row].WhsCode = selectedAlmacen;
        });




      } else {
        console.error('No se pudo obtener el item seleccionado:', args);
      }
    });
  };


     createListaLocalidadD1 = (row, cellvalue, editor) => {
    if (!editor) {
      console.error('Editor no está definido.');
      return;
    }

    editor.jqxDropDownList({
      source: this.state.dataComboLocalidadD1,
      displayMember: 'label',
      valueMember: 'value',
      filterable: true,
      // autoDropDownHeight: true,
    });
    editor.on('select', (event) => {


      const args = event.args;
      // console.log(args.item.checked);
      let selectedLocalidadD1= ""
      if (args && args.item) {
        selectedLocalidadD1 = args.item.value;
        // console.log(selectedCentroCostoD2);

        this.setState(prevState => {
          const updatedData = [...prevState.data];
          updatedData[row].OcrCodeD1 = selectedLocalidadD1;
        });




      } else {
        console.error('No se pudo obtener el item seleccionado:', args);
      }
    });
  };


   createListaCentroCostoD2 = (row, cellvalue, editor) => {
    if (!editor) {
      console.error('Editor no está definido.');
      return;
    }

    editor.jqxDropDownList({
      source: this.state.dataComboCentroCostoD2,
      displayMember: 'label',
      valueMember: 'value',
      filterable: true,
      // autoDropDownHeight: true,
    });
    editor.on('select', (event) => {


      const args = event.args;
      // console.log(args.item.checked);
      let selectedCentroCostoD2 = ""
      if (args && args.item) {
        selectedCentroCostoD2 = args.item.value;
        // console.log(selectedCentroCostoD2);

        this.setState(prevState => {
          const updatedData = [...prevState.data];
          updatedData[row].OcrCodeD2 = selectedCentroCostoD2;
        });




      } else {
        console.error('No se pudo obtener el item seleccionado:', args);
      }
    });
  };


    createListaDepartamentosD3 = (row, cellvalue, editor) => {
    if (!editor) {
      console.error('Editor no está definido.');
      return;
    }

    editor.jqxDropDownList({
      source: this.state.dataComboDepartamentosd3,
      displayMember: 'label',
      valueMember: 'value',
      filterable: true,
      // autoDropDownHeight: true,
    });
    editor.on('select', (event) => {


      const args = event.args;
      // console.log(args.item.checked);
      let selectedDepartamentosD3 = ""
      if (args && args.item) {
        selectedDepartamentosD3 = args.item.value;
        // console.log(selectedDepartamentosD3);

        this.setState(prevState => {
          const updatedData = [...prevState.data];
          updatedData[row].OcrCodeD3 = selectedDepartamentosD3;
        });




      } else {
        console.error('No se pudo obtener el item seleccionado:', args);
      }
    });
  };




  createListaIndicadorImpuesto = (row, cellvalue, editor) => {
    if (!editor) {
      console.error('Editor no está definido.');
      return;
    }

    editor.jqxDropDownList({
      source: this.state.dataComboIndicadorImpuesto,
      displayMember: 'label',
      valueMember: 'value',
      filterable: true,
      // autoDropDownHeight: true,
    });
    editor.on('select', (event) => {


      const args = event.args;
      // console.log(args.item.checked);
      let selectedIndicadorImpuesto = ""
      if (args && args.item) {
        selectedIndicadorImpuesto = args.item.value;
        // console.log(selectedIndicadorImpuesto);

        this.setState(prevState => {
          const updatedData = [...prevState.data];
          updatedData[row].Code = selectedIndicadorImpuesto;
        });




      } else {
        console.error('No se pudo obtener el item seleccionado:', args);
      }
    });
  };


  dataProyectos = async () => {
    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }

    this.setState({
      message: "",
      isLoading: true,
    });

    try {
      // let url = `${dominio}/get-produccion_vs_despachos_home2_Filter?date=${date}`;
      const response = await fetch(`${dominio}/get_ListaProyectos`, {
        // const response = await fetch('${dominio}/get_ListaProyectos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password
        }),
      });

      let data = await response.json();

      if (Object.entries(data).length === 0) {
        this.setState({
          message: "no data",
          isLoading: false,
        });
        return;
      }

      // Convertir a la estructura adecuada para jqxDropDownList
      let array_source = data.map(element => ({
        label: element.U_NombreProy,
        value: element.U_NombreProy
      }));

      this.setState({
        isLoading: false,
        message: "",
        dataComboProyectos: array_source,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        message: "error in server",
      });
    }
  };

  dataFases = async (selectedProject) => {

    // console.log(selectedProject);

    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }


    try {
      const response = await fetch(`${dominio}/get_ListaFases`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password,
          selectedProject
        }),
      });

      let data = await response.json();
      // console.log(data);

      if (Object.entries(data).length === 0) {
        this.setState({
          message: "no data",
          isLoading: false,
        });
        return;
      }

      // Convertir a la estructura adecuada para jqxDropDownList
      let array_source = data.map(element => ({
        label: element.U_Fase,
        value: element.U_Fase
      }));

      this.setState({
        isLoading: false,
        message: "",
        dataComboFases: array_source,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        message: "error in server",
      });
    }
  };

  dataAlmacenes = async () => {


    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }


    try {
      const response = await fetch(`${dominio}/get_ListaAlmacenes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password
        }),
      });

      let data = await response.json();

      // console.log(data);

      if (Object.entries(data).length === 0) {
        this.setState({
          message: "no data",
          isLoading: false,
        });
        return;
      }

      // Convertir a la estructura adecuada para jqxDropDownList
      let array_source = data.map(element => ({
        label: element.WhsCode,
        value: element.WhsCode
      }));

      this.setState({
        isLoading: false,
        message: "",
        dataComboAlmacenes: array_source,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        message: "error in server",
      });
    }
  };

  dataLocalidadD1 = async () => {


    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }


    try {
      const response = await fetch(`${dominio}/get_LocalidadD1`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password
        }),
      });

      let data = await response.json();

      // console.log(data);

      if (Object.entries(data).length === 0) {
        this.setState({
          message: "no data",
          isLoading: false,
        });
        return;
      }

      // Convertir a la estructura adecuada para jqxDropDownList
      let array_source = data.map(element => ({
        label: element.CentroCostoD1,
        value: element.OcrCodeD1
      }));

      this.setState({
        isLoading: false,
        message: "",
        dataComboLocalidadD1: array_source,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        message: "error in server",
      });
    }
  };



   dataCentroCostosD2 = async () => {
  
  
      var username = '';
      var password = '';
      let token = localStorage.getItem('token');
      let token_Data = JSON.parse(token);
  
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
        });
      }
  
      if (token_Data === null) {
        this.props.history.push('');
      }
  
  
      try {
        const response = await fetch(`${dominio}/get_CentroCostosD2`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username,
            password
          }),
        });
  
        let data = await response.json();
  
        // console.log(data);
  
        if (Object.entries(data).length === 0) {
          this.setState({
            message: "no data",
            isLoading: false,
          });
          return;
        }
  
        // Convertir a la estructura adecuada para jqxDropDownList
        let array_source = data.map(element => ({
          label: element.CentroCostoD2,
          value: element.OcrCodeD2
        }));
  
        this.setState({
          isLoading: false,
          message: "",
          dataComboCentroCostoD2: array_source,
        });
      } catch (error) {
        this.setState({
          isLoading: false,
          message: "error in server",
        });
      }
    };
  
  
  
      dataDepartamentosD3 = async () => {
  
  
      var username = '';
      var password = '';
      let token = localStorage.getItem('token');
      let token_Data = JSON.parse(token);
  
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
        });
      }
  
      if (token_Data === null) {
        this.props.history.push('');
      }
  
  
      try {
        const response = await fetch(`${dominio}/get_DepartamentosD3`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username,
            password
          }),
        });
  
        let data = await response.json();
  
        // console.log(data);
  
        if (Object.entries(data).length === 0) {
          this.setState({
            message: "no data",
            isLoading: false,
          });
          return;
        }
  
        // Convertir a la estructura adecuada para jqxDropDownList
        let array_source = data.map(element => ({
          label: element.CentroCostoD3,
          value: element.OcrCodeD3
        }));
  
        this.setState({
          isLoading: false,
          message: "",
          dataComboDepartamentosd3: array_source,
        });
      } catch (error) {
        this.setState({
          isLoading: false,
          message: "error in server",
        });
      }
    };
  



  dataIndicadorImpuesto = async () => {


    var username = '';
    var password = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push('');
    }


    try {
      const response = await fetch(`${dominio}/get_ListaIndicadorImpuesto`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password
        }),
      });

      let data = await response.json();

      // console.log(data);

      if (Object.entries(data).length === 0) {
        this.setState({
          message: "no data",
          isLoading: false,
        });
        return;
      }

      // Convertir a la estructura adecuada para jqxDropDownList
      let array_source = data.map(element => ({
        label: element.Code,
        value: element.Code
      }));

      this.setState({
        isLoading: false,
        message: "",
        dataComboIndicadorImpuesto: array_source,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        message: "error in server",
      });
    }
  };

  handleInputChangeComentario = (event, index) => {
    // const { name, value } = event.target;
    this.setState({
      Comments: event.target.value,
    });
  };



  render() {


    const { isLoading,  fecha_valido_hasta,  fecha_necesaria, is_descriptionDepartamento,  dataComboDepartamento,  } = this.state;






      const guardar = () => {
          this.setState({
            isLoading: true,
          });
    
          try {
            let username = "";
            let password = "";
            let token = localStorage.getItem("token");
            let token_Data = JSON.parse(token);
            if (token_Data !== null) {
              token_Data.forEach((element) => {
                username = element.usuarioSAP;
                password = element.contraseñaSAP;
              });
            }
    
            if (token_Data === null) {
              this.props.history.push("");
            }
    
    
            // Validaciones de campos obligatorios
            const {
              selectedDepartamentoId,
              Comments,
              data,
            } = this.state;
    
            if (!fecha_valido_hasta) {
              Swal.fire({
                icon: 'warning',
                title: 'Campo obligatorio',
                text: 'El campo "Fecha" es obligatorio.',
              });
              this.setState({ isLoading: false });
              return;
            }
    
            // if (!selectedCategoriaId) {
            //   Swal.fire({
            //     icon: 'warning',
            //     title: 'Campo obligatorio',
            //     text: 'El campo "Serie" es obligatorio.',
            //   });
            //   this.setState({ isLoading: false });
            //   return;
            // }
    
            if (!selectedDepartamentoId) {
              Swal.fire({
                icon: 'warning',
                title: 'Campo obligatorio',
                text: 'El campo "Categoria" es obligatorio.',
              });
              this.setState({ isLoading: false });
              return;
            }
    
            for (const item of data) {
    
    
              // if (!item.Codigo) {
              //   Swal.fire({
              //     icon: 'warning',
              //     title: 'Campo obligatorio',
              //     text: 'El campo "Articulo" es obligatorio en los detalles del documento.',
              //   });
              //   this.setState({ isLoading: false });
              //   return;
              // }
    
              if (!item.Descripcion) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Campo obligatorio',
                  text: 'El campo "Descripcion" es obligatorio en los detalles del documento.',
                });
                this.setState({ isLoading: false });
                return;
              }
    
    
    
              // if (!item.WhsCode) {
              //   Swal.fire({
              //     icon: 'warning',
              //     title: 'Campo obligatorio',
              //     text: 'El campo "Almacen" es obligatorio en los detalles del documento.',
              //   });
              //   this.setState({ isLoading: false });
              //   return;
              // }
    
    
              console.log("precio info es: ", item.Precio_Info);
    
    

          if (
  item.Precio_Info === "0" || 
  !item.Precio_Info || 
  !/^\d+(\.\d{1,2})?$/.test(item.Precio_Info) // Verifica formato correcto
) {
  Swal.fire({
    icon: 'warning',
    title: 'Campo obligatorio',
    text: item.Precio_Info === "0" || !item.Precio_Info
      ? 'El campo "Precio Info" es obligatorio y debe ser mayor que 0 en los detalles del documento.'
      : 'El campo "Precio Info" debe estar en el formato correcto, por ejemplo, 1000 o 1000.50.',
  });
  this.setState({ isLoading: false });
  return;
}

//      if (!item.Cantidad || isNaN(item.Cantidad) || parseFloat(item.Cantidad) <= 0) {
//   Swal.fire({
//     icon: 'warning',
//     title: 'Campo obligatorio',
//     text: !item.Cantidad
//       ? 'El campo "Cantidad" es obligatorio en los detalles del documento.'
//       : 'El campo "Cantidad" debe ser un número válido mayor que 0.',
//   });
//   this.setState({ isLoading: false });
//   return;
// }
    
              if (!Comments) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Campo obligatorio',
                  text: 'El campo "Comentario" es obligatorio.',
                });
                this.setState({ isLoading: false });
                return;
              }
    
            }
    
            if (!Comments) {
              Swal.fire({
                icon: 'warning',
                title: 'Campo obligatorio',
                text: 'El campo "Comentario" es obligatorio.',
              });
              this.setState({ isLoading: false });
              return;
            }
    
    
            const solicitudCompra = {
              username,
              password,
              Requester: username,
              DocType: "dDocument_Service",
              ApprovalStageCode: 47,
              DocDate: fecha_valido_hasta,
              DocDueDate: fecha_valido_hasta,
              TaxDate: fecha_valido_hasta,
              RequriedDate: fecha_valido_hasta,
              U_Categoria: this.state.selectedCategoriaId,
              RequesterDepartment: this.state.selectedDepartamentoId,

              DocObjectCode: 1470000113,
              Comments: this.state.Comments,
              // DocTotal: 500.0,
              DocumentLines: this.state.data.map((item) => ({
                Quantity: item.Cantidad,
                TaxCode: item.Code,
                ItemCode: item.Descripcion,
                Dscription: item.Descripcion,
                ItemDescription: item.Descripcion,
                RequiredDate: fecha_necesaria,
                UnitPrice: item.Precio_Info,
                Proyecto: item.Proyecto,
                Stock: item.Stock,
                Total: item.Total,
                U_Fase: item.U_Fase,
                WarehouseCode: "BCM01",
                OcrCodeD1: item.OcrCodeD1,
                OcrCodeD2: item.OcrCodeD2,
                OcrCodeD3: item.OcrCodeD3
    
              })),
            };
            console.log(solicitudCompra);
            
    
            // Primera solicitud para guardar la solicitud de compra
            fetch(`${dominio}/postSolicitudCompraServicio_ADM`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(solicitudCompra),
            })
              .then((res) => res.json())
              .then((data) => {
                const docEntry = data.DocEntry; // Obtén el DocEntry directamente de la respuesta

                      // Verificar si docEntry es válido
                               if (!docEntry) { // docEntry es "" o null o undefined
                                 Swal.fire({
                                   icon: "error",
                                   title: "Error al crear solicitud",
                                   text: "Verifique si su usuario tiene acceso a crear solicitudes de compra o contacte al administrador del sistema - Codigo error '801'",
                                 });
                                  this.setState({
                                       isLoading: false,
                                     });
                                 return; // Detener ejecución si no hay docEntry
                                 
                               }
               
                     
               
                               this.setState({
                                   isLoading: false,
                                 });
                                 Swal.fire({
                                   icon: "success",
                                   text: "Solicitud realizada",
                                   title: "Número de Documento: " + docEntry,
                                 }).then(() => {
                                     const adjunto = {
                                         DocEntry: docEntry,
                                         empresa: "MOSA",
                                         doc: this.state.file, // Asegúrate de que `file` contenga el archivo binario
                                       };
                                      // Segunda solicitud para guardar el archivo adjunto
                                      fetch(`${dominio}/postAdjuntosRequi_ADM`, {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                          "Content-Length": JSON.stringify(adjunto).length, // Tamaño del cuerpo de la solicitud
                                        },
                                        body: JSON.stringify(adjunto),
                                      })
               
                                         this.setState({
                                              isLoading: false,
                                            });
                                            Swal.fire({
                                              icon: "success",
                                              text: "Archivo adjuntado exitosamente",
                                              title: "Número de Documento: " + docEntry,
                                            }).then(() => {
                                              window.location.reload();
                                            })
               
               
                                        .catch((error) => {
                                          console.error("Error al adjuntar archivo:", error);
                                          Swal.fire({
                                            icon: "error",
                                            title: "Error al adjuntar archivo",
                                            text: "Verifique que el archivo adjunto sea una imagen o un PDF",
                                          });
                                           window.location.reload();
                                            this.setState({
                                              isLoading: false,
                                            });
                                        });
                                 });
               
               
                           
               
              })
              .catch((error) => {
                console.error("Error en la solicitud:", error);
              });
          } catch (error) {
            console.error("Error al enviar la solicitud:", error);
          }
        };

    const source = {
      localdata: this.state.data,
      datatype: "array",
      datafields: [
        { name: 'Codigo', type: 'string' },
        { name: 'Descripcion', type: 'string' },
        { name: 'Proyecto', type: 'string' },
        { name: 'U_Fase', type: 'string' },
        { name: 'WhsCode', type: 'string' },
        { name: 'OcrCodeD1', type: 'string' },
        { name: 'OcrCodeD2', type: 'string' },
        { name: 'OcrCodeD3', type: 'string' },
        { name: 'Stock', type: 'string' },
        { name: 'Precio_Info', type: 'string' },
        { name: 'Cantidad', type: 'string' },
        { name: 'Code', type: 'string' },
        { name: 'Total', type: 'string' },


      ],
      id: 'id'
    };

    const dataAdapter = new jqx.dataAdapter(source);


    const columns = [
      { text: '', datafield: 'delete', columntype: 'button', width: '4%', cellsrenderer: () => '-', buttonclick: (row) => this.handleDelete(row) },
      // { text: '', columntype: 'button', width: '4%', cellsrenderer: () => '+', buttonclick: (row) => { this.openModal(); }, },
      // { text: 'Codigo', datafield: 'Codigo', width: '11%', editable: true, },
      // { text: 'Descripcion', datafield: 'Descripcion', width: '72%', editable: true },
      
      { text: 'Descripcion', datafield: 'Descripcion',  width: '44%',
        editable: true,
        cellendedit: (row, datafield, columntype, oldvalue, newvalue) => {
          if (newvalue === oldvalue) {
            return;
          }

          // const precioInfo = this.state.data[row].Precio_Info || 0; // Usa 0 si no hay valor

          // const newTotal = parseFloat(precioInfo) * parseFloat(newvalue);

          this.setState(prevState => {
            const updatedData = [...prevState.data];
            updatedData[row] = {
              ...updatedData[row],
              Descripcion: newvalue,
              // Total: newTotal.toFixed(2)
            };
            return { data: updatedData };
          });
        }
      },
      { text: 'Proyecto', datafield: 'Proyecto', columntype: 'dropdownlist', createeditor: this.createListaProyectos, width: '10%' },
      { text: 'Fase Proyecto', datafield: 'U_Fase', width: '10%', columntype: 'dropdownlist', createeditor: this.createListaFases },
      // { text: 'Almacen', datafield: 'WhsCode', width: '10%', columntype: 'dropdownlist', createeditor: this.createListaAlmacenes },
      // { text: 'Stock', datafield: 'Stock', width: '6%', editable: false },
      { text: 'Localidad', datafield: 'OcrCodeD1', width: '14%', columntype: 'dropdownlist', createeditor: this.createListaLocalidadD1 },
      { text: 'Centro Costo', datafield: 'OcrCodeD2', width: '14%', columntype: 'dropdownlist', createeditor: this.createListaCentroCostoD2 },
      { text: 'Departamento', datafield: 'OcrCodeD3', width: '14%', columntype: 'dropdownlist', createeditor: this.createListaDepartamentosD3 },
      { text: 'Precio', datafield: 'Precio_Info', width: '4%', editable: true,


        cellendedit: (row, datafield, columntype, oldvalue, newvalue) => {
          if (newvalue === oldvalue) {
            return;
          }

          // const precioInfo = this.state.data[row].Precio_Info || 0; // Usa 0 si no hay valor

          // const newTotal = parseFloat(precioInfo) * parseFloat(newvalue);

          this.setState(prevState => {
            const updatedData = [...prevState.data];
            updatedData[row] = {
              ...updatedData[row],
              Precio_Info: newvalue,
              // Total: newTotal.toFixed(2)
            };
            return { data: updatedData };
          });
        }


       },
      // { text: 'Indicador Impuesto', datafield: 'Code', width: '8%', columntype: 'dropdownlist', createeditor: this.createListaIndicadorImpuesto },

      // { text: 'Total', datafield: 'Total', width: '5%', editable: false },



    ];

    return (


      <div className="content text-center" style={{ textAlign: "center", alignItems: "center" }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <div className="modal" tabIndex="-1" role="dialog" style={{ display: this.state.isModalOpen ? 'block' : 'none' }}>
                      <div className="modal-dialog-custom-width" role="document" >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Codigos</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModal}>
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body" style={{ height: '550px' }}>
                            {isLoading && <Loading />}
                            {!_.isEmpty(this.state.sourceGridCodigos) ? (

                              <div className="row">

                                <div className="col-sm-12">

                                  <JqxGrid
                                    ref={myGridModalArticulos}
                                    theme={"material"}
                                    width={"100%"}
                                    height={"600px"}
                                    // groupable={true}
                                    columns={this.state.columnsCodigos}
                                    source={this.state.sourceGridCodigos}
                                    // editable={true}
                                    filterable={true}
                                    selectionmode={"singlerow"}
                                    showfilterrow={true}
                                    altrows={true}
                                    enabletooltips={true}
                                    columnsresize={true}
                                    showtoolbar={true}
                                    sortable={true}
                                    // theme={"material"}
                                    showstatusbar={true}
                                    showaggregates={true}
                                  />

                                  <br />
                                  <br />
                                </div>

                              </div>

                            ) : (

                              ""
                            )}

                          </div>
                          <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                              Cerrar
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div id="alertContainer"></div>
                    <div>
                      <div style={{ fontSize: "20px" }}>Compras - Requisición por Servicio</div>
                      <br />
                      <br />
                      <br />
                      <div className="row">

                        <form onSubmit={this.handleSubmit}>
{/* 
                          <div className="col-sm-2">
                            <ControlLabel>Fecha de Contabilización: </ControlLabel>
                            <br />
                            <input type="" style={inputStyle} name="fecha_contabilizacion" value={fecha_contabilizacion} onChange={this.handleDateChangeFechaContabilizacion} />
                          </div>


                          <div className="col-sm-2">
                            <ControlLabel>Fecha del Documento: </ControlLabel>
                            <br />
                            <input type="" style={inputStyle} name="fecha_documento" value={fecha_documento} onChange={this.handleDateChangeFechaDocumento} />

                          </div> */}

                          <div className="col-sm-2">
                            <ControlLabel>Fecha: </ControlLabel>
                            <br />
                            <input type="date" style={inputStyle} name="fecha_valido_hasta" value={fecha_valido_hasta} onChange={this.handleDateChangeFechaValidoHasta} />

                          </div>

                          {/* <div className="col-sm-2">
                            <ControlLabel>Fecha Necesaria: </ControlLabel>
                            <br />
                            <input type="date" style={inputStyle} name="fecha_necesaria" value={fecha_necesaria} onChange={this.handleDateChangeFechaNecesaria} />

                          </div> */}

                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                        


                          {/* <div className="col-sm-2">
                            <label htmlFor="is_descriptionCategoria">Serie</label>
                            <select
                              value={is_descriptionCategoria} // Asegúrate de que value esté usando this.state
                              name="is_descriptionCategoria"
                              id="is_descriptionCategoria"
                              className="form-control"
                              onChange={this.onChangeCategoria}
                            >
                              <option value="Seleccione...">Seleccione...</option>
                              {dataComboCategoria && dataComboCategoria.map((res) => (
                                <option key={res[1]} value={res[1]}>{res[1]}</option>
                              ))}
                            </select>
                          </div> */}

                          <div className="col-sm-2">
                            <label htmlFor="is_descriptionDepartamento">Categoria</label>
                            <select
                              value={is_descriptionDepartamento} // Asegúrate de que value esté usando this.state
                              name="is_descriptionDepartamento"
                              id="is_descriptionDepartamento"
                              className="form-control"
                              onChange={this.onChangeDepartamento}
                            >
                              <option value="Seleccione...">Seleccione...</option>
                              {dataComboDepartamento && dataComboDepartamento.map((res) => (
                                <option key={res[1]} value={res[1]}>{res[1]}</option>
                              ))}
                            </select>
                          </div>


                          <br />
                          <br />
                          <br />

                          <br />
                          <br />

                          <div className="col-sm-1">
                            <Button type="submit" bsStyle="primary">
                              Agregar Articulo
                            </Button>
                          </div>
                        </form>
                      </div>
                      <JqxGrid
                        ref={gridRef}
                        width={"100%"}
                        autoheight={true}
                        source={dataAdapter}
                        columns={columns}
                        filterable={true}
                        selectionmode={"singlerow"}
                        altrows={true}
                        enabletooltips={true}
                        columnsresize={true}
                        showtoolbar={true}
                        sortable={true}
                        showstatusbar={true}
                        showaggregates={true}
                        editable={true}

                      />
                      <div >
                        <br />

                        <div className='divText'>
                          <label className='labelStyle'> Comments: </label>
                          <textarea style={inputStyle2} type="text" name="Comments" value={this.state.Comments} onChange={this.handleInputChangeComentario} />
                        </div>
                        <br />
                        <div className="form-group">
                          <div className="col-sm-3">

                            <label htmlFor="adjunto">Adjuntar archivo:</label>
                            <input
                              type="file"
                              className="form-control"
                              id="adjunto"
                              accept=".jpg,.png,.pdf"
                              onChange={this.handleFileChange}
                            />
                          </div>
                        </div>
                        <br /><br /><br />
                      </div>
                      <center>
                        <div>
                          <Button
                            onClick={guardar}
                            bsStyle="primary"
                            active
                          >
                            <i className="pe-7s-cloud-upload" />&nbsp;
                            Crear Solicitud.
                          </Button>
                        </div>
                      </center>
                    </div>

                  </div>


                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {})(Solicitud_Compras_Servicio);
const inputStyle = {
  width: "200px",
  height: "40px",
  padding: "10px",
  fontSize: "16px",
  borderRadius: "5px"
};

const inputStyle2 = {
  width: "400px",
  height: "100px",
  padding: "10px",
  fontSize: "16px",
  borderRadius: "5px"
};